class HeaderDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mouseEnterHandler = this.handleMouseEnter.bind(this);
    this.mouseLeaveHandler = this.handleMouseLeave.bind(this);
    this.hoverTimeout = null;
    this.mainDetailsToggle = null;
    this.summaryLink = null;
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector("details");
    if (!this.mainDetailsToggle) return;
    
    this.summaryLink = this.querySelector('summary a');
    
    // Add basic functionality
    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    
    // Add mouse hover support for desktop
    if (window.innerWidth >= 768) {
      this.addEventListener('mouseenter', this.mouseEnterHandler);
      this.addEventListener('mouseleave', this.mouseLeaveHandler);
    }
    
    // Disable default link behavior when menu is closed
    if (this.summaryLink) {
      this.summaryLink.addEventListener('click', this.handleLinkClick.bind(this));
    }
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.mouseEnterHandler);
    this.removeEventListener('mouseleave', this.mouseLeaveHandler);
    
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    const content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    if (!content) return;
  
    if (this.mainDetailsToggle.hasAttribute("open")) {
      // Opening
      content.style.opacity = '1';
      content.style.visibility = 'visible';
      content.style.transform = 'translateY(0)'; // Removed the translateX
    } else {
      // Closing  
      content.style.opacity = '0';
      content.style.visibility = 'hidden';
      content.style.transform = 'translateY(-10px)'; // Removed the translateX
    }
  }

  handleMouseEnter() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    
    this.hoverTimeout = setTimeout(() => {
      this.open();
    }, 150);
  }

  handleMouseLeave() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 300);
  }

  handleLinkClick(event) {
    // Prevent navigation when opening mega menu
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      event.preventDefault();
      this.open();
    }
  }

  open() {
    if (!this.mainDetailsToggle || this.mainDetailsToggle.hasAttribute('open')) return;
    
    // Close other open mega menus
    document.querySelectorAll('header-details-disclosure.mega details[open]').forEach(details => {
      if (details !== this.mainDetailsToggle) {
        details.removeAttribute('open');
      }
    });
    
    this.mainDetailsToggle.setAttribute('open', '');
    this.querySelector('summary').setAttribute('aria-expanded', 'true');
    
    // Add body class to prevent scrolling on mobile
    if (window.innerWidth < 768) {
      document.body.classList.add('mega-menu-open');
    }
  }

  close() {
    if (!this.mainDetailsToggle || !this.mainDetailsToggle.hasAttribute('open')) return;
    
    this.mainDetailsToggle.removeAttribute('open');
    this.querySelector('summary').setAttribute('aria-expanded', 'false');
    
    // Remove body class
    document.body.classList.remove('mega-menu-open');
  }
}

// Only define if not already defined
if (!customElements.get('header-details-disclosure')) {
  customElements.define('header-details-disclosure', HeaderDetailsDisclosure);
}